<template>
  <div>
    <div class="col secondary-footer" style="">
      <div class="container">
        <div class="row" style="padding: 20px">
          <h5><strong>About Hireclap</strong></h5>
          <p>Hireclap is the largest video resume based job site in India. More than 3 million+ jobseekers registered with Hireclap, over 5000 companies used our recruitment services to hire candidates for its entry-level / fresher hiring and the database is growing daily.</p>
          <p>Job seekers can upload their 2-minute video resume -Visume, to showcase who they are and why a company should hire them. A video profile is an opportunity to describe yourself to a company beyond your resume.</p>
          <p>Companies can post free jobs and shortlist best matching candidates from video profiles. Recruiters can use the latest recruitment tools, reach out to the largest pool of active job seekers and make the data driven hiring decisions virtually.</p>
        </div>
        <div class="card-deck">
          <div class="card" style="background: transparent;border: none;">
            <div class="card-body">
              <h5 class="card-title"><strong>Need help?</strong></h5>
              <a href="mailto:recruit@hireclap.com"><h6>recruit@hireclap.com</h6></a>
              <h6>+91 9037 156 256</h6>
              <div class="btn mt-7"><a href="/recruit/contact-us" class="footerBtn btn px-2" target="noopener">Contact  Us</a></div>
            <div class="row gap20"></div>                        
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>Candidate zone</strong></h5>
            <p class="card-text">
              <a class="flink" href="/">Post visume</a>
              <a class="flink" href="/">Candidate services</a>
            </p>
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>Employer zone</strong> </h5>
            <p class="card-text">
              <a class="flink" href="/recruit" target="noopener">Free job posting</a>
              <a class="flink" target="_blank" href="/">Recruitment package</a>
              <a class="flink" target="_blank" href="/">Resume search</a>
              <a class="flink" target="_blank" href="/">End to end consulting</a>
              <a class="flink" target="noopener" href="https://www.assessengine.com/">Online assessment <span><i class="mdi mdi-star-circle" style="color:#007bff"></i></span></a>
              <a class="flink" target="_blank" href="/">Application management system</a>
              <a class="flink" href="/recruit/package-pricing" target="noopener">Pricing</a>
            </p>
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>Institute zone</strong></h5>
            <p class="card-text">
              <a class="flink" target="_blank" href="/institutes">List your institute</a>
              <!-- <a class="flink" target="_blank" href="/training-institutes">Institute list</a>
              <a class="flink" target="_blank" href="/training-courses">Course list</a> -->
              <a class="flink" target="_blank" href="/">Virtual campus placement</a>
              <a class="flink" target="_blank" href="/">Virtual placement cell (VPCell)</a>
            </p>
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>College zone</strong></h5>
            <p class="card-text">
              <a class="flink" target="_blank" href="/colleges/register">List your college</a>
              <!-- <a class="flink" target="_blank" href="/view-colleges">College list</a> -->
              <a class="flink" target="_blank" href="/">Campus placements </a>
              <a class="flink" target="_blank" href="/">Placement preparation </a>
              <a class="flink" target="_blank" href="/">Mock assessments </a>
            </p>
          </div>
        </div>
      </div>
    </div> 
    </div>
    <div class="footer">
      <div class="container p-3">
        <div class="row">
          <div class="col-lg-5 col-md-12  alignmob">
            <p class="content-center mb-0" v-if="this.year">© {{year}} <a href="/" style="color:#ffff">Hireclap</a> | Hire best matching candidates</p>
          </div>
          <div class="col-lg-4 col-md-6  alignmob">
            <p class="content-center mb-0"><small class="mb-0"><a href="/privacy" target="noopener" class="flink text-decoration-none">Privacy Policy </a>|<a href="/terms" target="noopener" class="flink text-decoration-none"> Terms &amp; Conditions</a></small></p>
          </div>
          <div class="col-lg-3 col-md-6 alignmob">
            <a href="https://www.facebook.com/Hireclap" aria-label="facebook" target="noopener">
              <i class="mdi mdi-facebook mdi-footer"></i>
            </a>
            <a href="https://twitter.com/hireclap" aria-label="twitter" target="noopener">
              <i class="mdi mdi-twitter mdi-footer"></i>
            </a>
            <a href="https://www.linkedin.com/company/hireclap" aria-label="linkedin" target="noopener">
              <i class="mdi mdi-linkedin mdi-footer"></i>
            </a>
            <a href="https://www.youtube.com/channel/UC_Rhjfe3TniDTGLn8nxcu0Q" aria-label="youtube" target="noopener">
              <i class="mdi mdi-youtube mdi-footer"></i>
            </a>
            <a href="https://www.instagram.com/hireclap" aria-label="instagram" target="noopener">
              <i class="mdi mdi-instagram mdi-footer"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/hire.css';
export default {
  name: "App-footer",
  data(){
    return{
      year:null,
    }
  },
  beforeMount(){
    this.year = new Date().getFullYear();
  },
}
</script>
<style scoped>
.footerBtn {border: 1px solid #0054ad;color: #0054ad;}.footerBtn:hover{color: #212529}
</style>